exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".white{\n\tcolor: white!important;\n}\n\ninput.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/shree_translogic_dashboard/src/app/forgot-password/email/email.component.css
// module id = ../../../../../src/app/forgot-password/email/email.component.css
// module chunks = main